import { fireEvent } from '@testing-library/dom'
import React from 'react'
import {Container} from 'react-bootstrap'
import Brain_Magnetic_Resonance_Imaging from "./brain_magnetic"
import Title from '../../utilities/other/title';
import Datscan from "./datscan"
import YesNoNormal from "./YesNoNormal"
import Polysomnography from "./polysomnography"
import  Fdg_pet_brain from "./fdg_pet_brain"
import Samples from "./samples"
import './style.css'
class ImagingBiomarkers extends React.Component{
    constructor(props){
        super(props)
        this.state ={
           bmri:{stractural_abnomarlities_type:"",stractural_abnomarlities_type_other:""},
           datscan:{},
           ibzm_spect:{},
           mibg_spect:{},
           polysomnography:{},
           fdg_pet_brain:{},
           csf_sample:{},
           serum_sample:{},
           pmbcs_exosomes:{}
        }
        
    }
    checkforKeyword = (field,name,keyword)=>{
        try{
            if(this.state[field][name].includes(keyword)){ // if true return false to enable the field (props.disabled=false)
                return false
            }
            else{ // if false return true to disable the field (props.disabled=true)
                return true 
            }
        }
        catch{
            return true
        }
    }
    checkYesOrNo = (field,name)=>{
        if(this.state[field][name]=="Yes"){
            return true
        }
        else{
            return false
        }
    }
    StateCleaner = (field,name) =>{
        if (typeof name === 'object'){
            this.setState((prevState)=>({
                ...prevState,
                [field]:{
                    ...prevState[field],
                    ...name
                }
            }))
        } 
        else{
            this.setState((prevState)=>({
                ...prevState,
                [field]:{
                    ...prevState[field],
                    [name]:""
                }
            }))
        }
    }
    handleChangeState = async(name,state) =>{
        await this.setState((prevState)=>({
            ...prevState,
            [name]:state
        }))
    }
    // componentDidUpdate(prevProps,prevState){
    //     if(prevState!=this.state ){
    //         this.props.handler(this.state)
    //         if(this.props.data!=null){
                
    //         }
    //     }
    // }
   async componentDidMount(){
        if(this.props.data!=null){
           await this.setState(this.props.data)
        }
    }
    handleChange = async(field,event)=>{
    
        /*
        If event triggered by form change then setState using event.target accordingly.
        Else setState with "artificial event" created by the clearState Function using event
        */
        const {name,value} = (event.target?event.target:event) 
        
        await this.setState((prevState)=>({
                ...prevState,
                [field]:{
                    ...prevState[field],
                    [name]:value
                }
            }))
        
        this.props.handler(this.state)
        
    }
   
    render(){
        return(
            <Container>
             <Title>Imaging and Biomarkers</Title><br/>
                <div className={'bmri'}>
                    <Brain_Magnetic_Resonance_Imaging 
                    handler={this.handleChange} 
                    check={this.checkYesOrNo}
                    data={this.props.data!=null?this.state.bmri:null}
                    disabled={this.props.disabled}
                    clean={this.StateCleaner}
                    checkforKeyword={this.checkforKeyword}
                    />
                </div>

                <div className={'datscan'}>
                    <Datscan 
                    handler={this.handleChange} 
                    check={this.checkYesOrNo}
                    data={this.props.data!=null?this.state.datscan:{}}
                    disabled={this.props.disabled}
                    clean={this.StateCleaner}
                    edit={this.props.disabled==true ?true:false}
                    
                    />
                </div>
                <div className="yes-no">
                    <YesNoNormal 
                    handler={this.handleChange} 
                    check={this.checkYesOrNo}
                    data={this.state.ibzm_spect}
                    disabled={this.props.disabled}
                    clean={this.StateCleaner}
                    edit={this.props.disabled==true ?true:false}
                    stateName={"ibzm_spect"}
                    name={'ibzm_spect'}
                    title={"IBZM-SPECT"}
                />
                </div>
                <div className={'yes-no'}>
                    <YesNoNormal 
                    handler={this.handleChange} 
                    check={this.checkYesOrNo}
                    data={this.state.mibg_spect}
                    disabled={this.props.disabled}
                    clean={this.StateCleaner}
                    edit={this.props.disabled==true ?true:false}
                    stateName={"mibg_spect"}
                    name={'mibg_spect'}
                    title={"MIBG-SPECT"}
                />
                </div>

                <div className="poly">
                    <Polysomnography 
                    handler={this.handleChange} 
                    check={this.checkYesOrNo}
                    data={this.state.polysomnography}
                    disabled={this.props.disabled}
                    clean={this.StateCleaner}
                    edit={this.props.disabled==true ?true:false}
                    stateName={"mibg_spect"}
                    name={'mibg_spect'}
                    title={"MIBG-SPECT"}
                />
                </div>
                <div className="fdg">
                    <Fdg_pet_brain 
                    handler={this.handleChange} 
                    check={this.checkYesOrNo}
                    data={this.state.fdg_pet_brain}
                    disabled={this.props.disabled}
                    clean={this.StateCleaner}
                    edit={this.props.disabled==true ?true:false}
                    />
                </div>
                <div className="sample-style">
                    <Samples
                    handler={this.handleChange} 
                    check={this.checkYesOrNo}
                    data={this.state.serum_sample}
                    disabled={this.props.disabled}
                    clean={this.StateCleaner}
                    edit={this.props.disabled==true ?true:false}
                    name={'serum_sample'}
                    title={"Serum Sample"}
                    sampleName={'serum_sample'}
                    
                    />
                </div>
                <div className="sample-style">
                    <Samples
                    handler={this.handleChange} 
                    check={this.checkYesOrNo}
                    data={this.state.pmbcs_exosomes}
                    disabled={this.props.disabled}
                    clean={this.StateCleaner}
                    edit={this.props.disabled==true ?true:false}
                    name={'pmbcs_exosomes'}
                    title={"PMBCs/exosomes"}
                    sampleName={'pmbcs_exosomes'}
                    
                    />
                </div>
                <div className="sample-style">
                    <Samples className={'styles'}
                    handler={this.handleChange} 
                    check={this.checkYesOrNo}
                    data={this.state.csf_sample}
                    disabled={this.props.disabled}
                    clean={this.StateCleaner}
                    edit={this.props.disabled==true ?true:false}
                    name={'csf_sample'}
                    title={"CSF Sample"}
                    sampleName={'csf_sample'}
                    
                    />
                </div>

            </Container>
        )
    }
}
ImagingBiomarkers.defaultProps ={
    data:null
}
export default ImagingBiomarkers